import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import CompanyOdsRefrigerantLog from "../child/company-ods-refrigerant-log";

const ViewCompanySupplyAndDischargeLog = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("id", id);

    post(ApiURL.company_supply_and_discharge_get, fd).then((res) => {
      if (res?.status) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  return (
    <>
      <h2>View Supply and Discharge Log</h2>
      <CompanyOdsRefrigerantLog logs={[details]} />
    </>
  );
};

export default ViewCompanySupplyAndDischargeLog;
